import { render } from "./SendMessageList.vue?vue&type=template&id=1f248a66&scoped=true"
import script from "./SendMessageList.vue?vue&type=script&lang=js"
export * from "./SendMessageList.vue?vue&type=script&lang=js"

import "./SendMessageList.vue?vue&type=style&index=0&id=1f248a66&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f248a66"]])

export default __exports__